import React from 'react'
import './index.less'

export default class Footer extends React.Component{
    render (){
        return(
            <div className="footer">
                成都酱游网络科技有限公司版权所有©2018 酱游科技 蜀ICP 备 15020111 号
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer/index.js